import Users from "../Users/users";
import { Routes, Route } from "react-router-dom";
import DashboardComponent from "../../../components/DashboardComps";
import useAssignment from "../../../hooks/useAssignment";

//Sub pages
import Home from "./home";
import { useReportWrapper, useStoreWrapper } from "../../../store/store";
import Incident from "../IncidentsList";
import { doHandleTransform } from "../../../utils/helpers/incidentListUtils";

const Dashboard = () => {
  const { facilitiesReportData } = useReportWrapper((state) => ({
    facilitiesReportData: state.facilitiesReportData,
  }));
  const { user } = useStoreWrapper((state) => ({ user: state.user }));

  const facilitiesCols = [
    {
      Header: "Facility Name",
      accessor: "name",
    },
    {
      Header: "Staff Count",
      accessor: "staffNumber",
    },
    {
      Header: "Total Number of Signatures",
      accessor: "signatureNumber",
    },
  ];

  // facilities data
  const { getSystemFacilities } = useAssignment({
    userId: user?.userId,
  });
  const { isLoading: facilitiesLoading } = getSystemFacilities;

  const tableFacilitiesReportData =
    facilitiesReportData?.map((item: any) => doHandleTransform(item)) || [];

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route
        path="/facilities"
        element={
          <DashboardComponent
            title="facilities"
            columns={facilitiesCols}
            data={tableFacilitiesReportData}
            isLoading={facilitiesLoading}
          />
        }
      />
      <Route path="/incidents" element={<Incident title="incidents " />} />
      <Route path="/active-staff" element={<Users />} />
    </Routes>
  );
};

export default Dashboard;
